<template>
  <loading v-if="listLoading"></loading>
  <div class="forumDetails1" v-else>
    <div class="forum-detail1" v-if="details">
      <!-- 标题 -->
      <div class="forum-detail-title">{{ details.title }}</div>
      <!-- 用户 -->
      <div class="forum-detail-user">
        <div
          class="forum-detail-user-left"
          @click.stop="goUserDetails(details.user.id)"
        >
          <img
            class="avatar"
            :src="details.user ? details.user.avatar : ''"
            alt=""
          />
          <img
            src="../../assets/image/gx_icon.png"
            v-if="details.user.is_official_user"
            class="gx_icon"
            alt=""
          />
          <div class="forum-detail-user-left-msg">
            <div class="forum-detail-user-left-msg-name">
              {{ details.user ? details.user.nickname : "" }}
              <span class="gx_text" v-if="details.user.is_official_user">
                官方
              </span>
            </div>
            <div class="forum-detail-user-left-msg-time">
              {{ details.dateTime }}
            </div>
          </div>
        </div>
        <div v-if="details.user.id !== this.$store.getters.getUserInfo.id">
          <div
            v-if="details.user.is_follow == 0"
            class="forum-detail-user-right"
            @click.stop="followUser(details.user.id)"
          >
            <i class="el-icon-plus"></i>
            <div class="el-icon-name">关注</div>
          </div>
          <div
            v-else
            class="forum-detail-user-right"
            @click.stop="followUser(details.user.id)"
          >
            <div class="el-icon-name">取消关注</div>
          </div>
        </div>
      </div>
      <!-- 详情内容 -->
      <div class="forum-detail-content">{{ details.content }}</div>
      <!-- 详情图片 -->
      <div class="forum-detail-img">
        <img
          v-for="(item, index) in details.images"
          :key="index"
          :src="item"
          alt=""
        />
      </div>
      <!-- 详情操作 -->
      <div class="forum-detail-operation">
        <!-- 点赞 -->
        <div class="forum-detail-operation-box" @click.stop="postLike">
          <img
            v-if="details.is_like == 0"
            src="../../assets/image/like.png"
            alt=""
          />
          <img v-else src="../../assets/image/checkLike.png" alt="" />
          <div>{{ details.like_num }}次赞</div>
        </div>
        <!-- 评论 -->
        <div class="forum-detail-operation-box">
          <img src="../../assets/image/comment.png" alt="" />
          <div>{{ details.comment_num }}条评论</div>
        </div>
        <!-- 收藏 -->
        <div class="forum-detail-operation-box" @click.stop="collect">
          <img
            v-if="details.is_collect == 0"
            src="../../assets/image/collection.png"
            alt=""
          />
          <img v-else src="../../assets/image/checkCollect.png" alt="" />
          <div>{{ details.is_collect == 0 ? "收藏" : "已收藏" }}</div>
        </div>
        <!-- 分享 -->
        <div class="forum-detail-operation-box">
          <img src="../../assets/image/share.png" alt="" />
          <div>分享</div>
        </div>
      </div>
    </div>
    <!-- 帖子评论 -->
    <div class="forum-comment">
      <!-- 发布评论 -->
      <div class="forum-comment-release">
        <el-input
          @focus="focus"
          clearable
          v-model="forum.content"
          placeholder="写下你的评论…"
        ></el-input>
        <el-button
          type="primary"
          :loading="btnLoading"
          @click.stop="setComment()"
          >发布</el-button
        >
      </div>
      <!-- 评论列表 -->
      <div
        class="forum-comment-box"
        v-for="(item, index) in commentList"
        :key="index"
      >
        <img
          :src="item.user.avatar"
          alt=""
          @click.stop="goUserDetails(item.user.id)"
        />
        <div class="forum-comment-box-right">
          <!-- 用户昵称 -->
          <div class="forum-comment-box-right-name">
            <div>{{ item.user.nickname }}</div>
            <div>{{ item.dateTime }}</div>
          </div>
          <!-- 评论内容 -->
          <div class="forum-comment-box-right-content">{{ item.content }}</div>
          <!-- 评论操作 -->
          <div class="forum-comment-box-right-operation">
            <!-- 点赞 -->
            <div
              class="forum-comment-box-right-operation-box"
              @click.stop="commentLove(item.id, 'parent', index)"
            >
              <img
                v-if="item.is_like == 0"
                src="../../assets/image/like.png"
                alt=""
              />
              <img v-else src="../../assets/image/checkLike.png" alt="" />
              <div>{{ item.like_num }}</div>
            </div>
            <!-- 回复 -->
            <div
              class="forum-comment-box-right-operation-box"
              @click.stop="reply(item)"
            >
              <img src="../../assets/image/comment.png" alt="" />
              <div>{{ item.comment_num }}</div>
            </div>
            <div
              class="forum-comment-box-right-operation-box"
              @click.stop="reply(item)"
            >
              <!-- <img src="../../assets/image/comment.png" alt=""> -->
              <div>回复</div>
            </div>
          </div>
          <!-- 发布评论 -->
          <div class="forum-comment-release" v-if="item.isReply">
            <el-input
              @blur="blur(item)"
              clearable
              :autofocus="true"
              v-model="forumReply.content"
              :placeholder="placeholder"
            ></el-input>
            <el-button
              type="primary"
              :loading="replyLoading"
              @click.stop="setReplyComment()"
              >发布</el-button
            >
          </div>
          <!-- 评论回复 -->
          <div
            class="forum-comment-box-right-reply"
            v-for="(item1, index1) in item.post_messageList"
            :key="index1"
          >
            <img
              :src="item1.user.avatar"
              alt=""
              @click.stop="goUserDetails(item1.user.id)"
            />
            <div class="forum-comment-box-right-reply-right">
              <!-- 回复账号 -->
              <div class="forum-comment-box-right-reply-right-userMsg">
                <div class="forum-comment-box-right-reply-right-user">
                  <div>{{ item1.user.nickname }}</div>
                  <div>回复</div>
                  <div>{{ item.user.nickname }}</div>
                </div>
                <div class="forum-comment-box-right-reply-right-time">
                  {{ item1.dateTime }}
                </div>
              </div>
              <!-- 回复内容 -->
              <div class="forum-comment-box-right-reply-right-content">
                {{ item1.content }}
              </div>
              <!-- 回复操作 -->
              <div class="forum-comment-box-right-reply-right-operation">
                <img
                  v-if="item1.is_like == 0"
                  src="../../assets/image/like.png"
                  alt=""
                  @click.stop="commentLove(item1.id, 'child', index, index1)"
                />
                <img
                  v-else
                  src="../../assets/image/checkLike.png"
                  alt=""
                  @click.stop="commentLove(item1.id, 'child', index, index1)"
                />
                <div>{{ item1.like_num }}</div>
              </div>
            </div>
          </div>
          <!-- 展开全部 -->
          <div
            style="cursor: pointer"
            v-if="!item.isAllReply && item.post_message.length > 1"
            class="lookMore"
            @click.stop="allReply(index)"
          >
            展开剩下{{ item.post_message.length - 1 }}条回复
          </div>
        </div>
      </div>
      <!-- 加载更多到底 -->
      <p class="noMore" v-if="noMore && commentList.length != 0">已经到底了~</p>
      <!-- 无数据 -->
      <div class="nodata" v-if="commentList.length == 0">
        <img src="../../assets/image/noData.png" alt="" />
        <span>暂无结果</span>
      </div>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import { diffTime } from "../../utils/common.js";
import loading from "@/components/loading/loading.vue";
// import { mapMutations } from "vuex";
export default {
  components: { loading },
  inject: ["reload"],
  data() {
    return {
      listLoading: true,
      placeholder: "写下你的评论…",
      replyList: [],
      isAllReply: false,
      replyList: [],
      details: null,
      commentList: [],
      forum: {
        forum_post_id: "",
        forum_post_message_id: "",
        reply_id: "",
        content: "",
        reply_post_message_id: "",
      },
      forumReply: {
        forum_post_id: "",
        forum_post_message_id: "",
        reply_id: "",
        content: "",
        reply_post_message_id: "",
      },
      query: {
        page: 1,
        limit: 10,
        forum_post_id: "",
      },
      noMore: false,
      btnLoading: false,
      replyLoading: false,
      id: "",
    };
  },
  created() {
    this.query.forum_post_id = this.$route.query.forum_post_id;
    if (this.$store.getters.getUserInfo.nickname) {
      this.getList();
      this.getCommentList();
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll); // 监听（绑定）滚轮滚动事件
  },
  destroyed() {
    console.log("组件被销毁");
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
  },
  methods: {
    focus() {
      this.commentList.forEach((x) => {
        x.isReply = false;
      });
      this.forum.content = "";
    },
    handleScroll() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      //滚动条到底部的条件
      if (scrollTop + windowHeight == scrollHeight) {
        if (!this.noMore) {
          console.log("触底");
          this.query.limit += 10;
          this.getCommentList();
        }
        //写后台加载数据的函数
        // console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
      }
    },
    // 详情
    getList() {
      this.listLoading = true;
      request({
        url: "/api/userend/post/postDetails",
        method: "get",
        params: { forum_post_id: this.$route.query.forum_post_id },
      }).then((response) => {
        this.details = response.data;
        this.details.dateTime = diffTime(response.data.created_at);
        this.listLoading = false;
      });
    },
    // 关注
    followUser(id) {
      this.commentList.forEach((x) => {
        x.isReply = false;
      });
      request({
        url: "/api/userend/post/followUser",
        method: "post",
        params: { user_id: id },
      }).then((response) => {
        this.details.user.is_follow = !this.details.user.is_follow;
        if (this.details.user.is_follow == 0) {
          this.$message("已取消");
        } else {
          this.$message.success("已关注");
        }
        this.$parent.info();
      });
    },
    blur(item) {
      console.log(item);
      this.commentList.forEach((x) => {
        if (x.id == item.id) {
          x.isReply = false;
        } else {
          x.isReply = false;
        }
      });
    },
    reply(item) {
      this.replyLoading = false;
      this.id = item.id;
      this.commentList.forEach((x) => {
        if (x.id == item.id) {
          x.isReply = true;
        } else {
          x.isReply = false;
        }
      });
      this.placeholder = "回复:" + item.user.nickname;
      if (item) {
        this.forumReply.forum_post_message_id = item.id;
      }
    },
    // 发布评论
    setComment() {
      this.btnLoading = true;
      this.forum.forum_post_id = this.$route.query.forum_post_id;
      request({
        url: "/api/userend/post/comment",
        method: "post",
        params: this.forum,
      })
        .then((response) => {
          this.forum = {
            forum_post_id: "",
            forum_post_message_id: "",
            reply_id: "",
            content: "",
            reply_post_message_id: "",
          };
          this.$message.success("评论成功");
          this.details.comment_num += 1;
          this.isReply = false;
          this.getCommentList();
          this.btnLoading = false;
          this.$parent.info();
        })
        .catch(() => {
          console.log("发送失败");
          this.btnLoading = false;
        });
    },
    // 发布评论
    setReplyComment() {
      this.replyLoading = true;
      this.forumReply.forum_post_id = this.$route.query.forum_post_id;
      request({
        url: "/api/userend/post/comment",
        method: "post",
        params: this.forumReply,
      })
        .then((response) => {
          this.forumReply = {
            forum_post_id: "",
            forum_post_message_id: "",
            reply_id: "",
            content: "",
            reply_post_message_id: "",
          };
          this.$message.success("评论成功");
          this.details.comment_num += 1;
          this.isReply = false;
          this.getCommentList();
          this.replyLoading = false;
          this.$parent.info();
        })
        .catch(() => {
          console.log("发送失败");
          this.replyLoading = false;
        });
    },
    // 评论列表
    getCommentList() {
      request({
        url: "/api/userend/post/allComment",
        method: "get",
        params: this.query,
      }).then((response) => {
        response.data.forEach((item, index) => {
          (item.isAllReply = false),
            (item.isReply = false),
            (item.dateTime = diffTime(item.created_at));
        });
        this.commentList = response.data;
        let arr = [];
        arr = response.data;
        for (var i = 0; i < arr.length; i++) {
          for (var j = 0; j < arr[i].post_message.length; j++) {
            arr[i].post_message[j].dateTime = diffTime(
              arr[i].post_message[j].created_at
            );
            if (j <= 0) {
              arr[i].post_messageList = [];
              arr[i].post_messageList.push(arr[i].post_message[j]);
            }
          }
        }
        this.commentList = arr;
        if (this.commentList.length < this.query.limit) {
          this.noMore = true;
        }
        this.noData = this.commentList.length == 0;
      });
    },
    // 帖子点赞
    postLike() {
      this.commentList.forEach((x) => {
        x.isReply = false;
      });
      request({
        url: "/api/userend/post/postLike",
        method: "post",
        params: { forum_post_id: this.$route.query.forum_post_id },
      }).then((response) => {
        this.details.is_like = !this.details.is_like;
        if (this.details.is_like == 0) {
          this.details.like_num -= 1;
        } else {
          this.details.like_num += 1;
        }
      });
    },
    // 评论点赞
    commentLove(id, type, index, index1) {
      this.commentList.forEach((x) => {
        x.isReply = false;
      });
      request({
        url: "/api/userend/post/commentLike",
        method: "post",
        params: { forum_post_message_id: id },
      }).then((response) => {
        // 如果是父级评论点赞
        if (type == "parent") {
          this.commentList[index].is_like = !this.commentList[index].is_like;
          if (this.commentList[index].is_like == 0) {
            this.commentList[index].like_num -= 1;
          } else {
            this.commentList[index].like_num += 1;
          }
        }
        // 否则是回复点赞
        else {
          this.commentList[index].post_messageList[index1].is_like =
            !this.commentList[index].post_messageList[index1].is_like;
          if (this.commentList[index].post_messageList[index1].is_like == 0) {
            this.commentList[index].post_messageList[index1].like_num -= 1;
          } else {
            this.commentList[index].post_messageList[index1].like_num += 1;
          }
        }
      });
    },
    // 帖子收藏
    collect() {
      request({
        url: "/api/userend/post/collect",
        method: "post",
        params: { id: this.$route.query.forum_post_id },
      }).then((response) => {
        this.details.is_collect = !this.details.is_collect;
        this.$parent.info();
      });
    },
    // 回复回复
    replyTo(my, you) {
      this.placeholder = my + "回复" + you + ":";
    },
    // 前往用户详情
    goUserDetails(id) {
      this.$router.push({
        path: "/forum/userDetails",
        query: {
          user_id: id,
        },
      });
    },
    // 显示全部
    allReply(index) {
      this.commentList[index].isAllReply = true;
      this.commentList[index].post_messageList =
        this.commentList[index].post_message;
    },
  },
};
</script>
<style lang="scss">
.forumDetails1 {
  // width: 100%;
  padding: 20px 30px;
  .forum-detail1 {
    border-bottom: 1px solid #f9fafd;
    padding: 9px 0 20px 0;
    .forum-detail-title {
      font-size: 22px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1e2134;
      line-height: 30px;
    }
    .forum-detail-user {
      margin-top: 15px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      .forum-detail-user-left {
        cursor: pointer;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        position: relative;
        .gx_icon {
          position: absolute;
          left: 30px;
          bottom: -10px;
          width: 30px;
          height: 30px;
        }
        .avatar {
          width: 52px;
          height: 52px;
          border-radius: 50%;
        }
        .forum-detail-user-left-msg {
          margin-left: 15px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .forum-detail-user-left-msg-name {
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #1e2134;
            .gx_text {
              width: 30px;
              height: 16px;
              border-radius: 4px;
              color: #fff;
              font-size: 10px;
              padding: 2px 4px;
              background: linear-gradient(154deg, #fff116 0%, #ff8703 100%);
              margin-left: 5px;
            }
          }
          .forum-detail-user-left-msg-time {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #858585;
          }
        }
      }
      .forum-detail-user-right {
        cursor: pointer;
        margin-left: 40px;
        height: 30px;
        background: #f5fafe;
        border-radius: 15px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 0 15px;
        .el-icon-plus {
          size: 16px;
          color: #3d7eff;
        }
        .el-icon-name {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #3d7eff;
        }
      }
    }
    .forum-detail-content {
      margin-top: 20px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1e2134;
      line-height: 30px;
    }
    img {
      max-width: 100% !important;
      height: auto !important;
    }
    .forum-detail-img {
      max-width: 100% !important;
      height: auto !important;
      // padding:0 30px;
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
    }
    .forum-detail-operation {
      margin-top: 21px;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      .forum-detail-operation-box {
        cursor: pointer;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin-left: 20px;
        img {
          width: 20px;
          height: 20px;
        }
        div {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #506176;
          margin-left: 8px;
        }
      }
    }
  }
  .forum-comment {
    padding: 20px 0;
    .noMore {
      text-align: center;
      padding: 5px 0 15px 15px;
    }
    .nodata {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 357px;
        height: 300px;
      }
      span {
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
      }
    }
    .forum-comment-release {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .el-input__inner {
        width: 98%;
        border: none;
        background-color: #f9fafd;
        height: 50px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
      .el-button {
        width: 104px;
        height: 50px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }
    }
    .forum-comment-box {
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      padding-bottom: 15px;
      border-bottom: 1px solid #f9fafd;
      img {
        cursor: pointer;
        width: 55px;
        height: 55px;
        border-radius: 50%;
      }
      .forum-comment-box-right {
        margin-left: 10px;
        width: 100%;
        padding: 7px 0 0 0;
        // border-bottom: 1px solid #F9FAFD;
        .forum-comment-box-right-name {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          div {
            &:nth-child(1) {
              font-size: 18px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #1e2134;
            }
            &:nth-child(2) {
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #858585;
            }
          }
        }
        .forum-comment-box-right-content {
          margin-top: 8px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #1e2134;
          line-height: 30px;
        }
        .forum-comment-box-right-operation {
          margin-top: 16px;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          padding-bottom: 20px;
          border-bottom: 1px solid #f9fafd;
          .forum-comment-box-right-operation-box {
            cursor: pointer;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            margin-right: 21px;
            img {
              width: 20px;
              height: 20px;
            }
            div {
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #506176;
              margin-right: 5px;
            }
          }
        }
        .forum-comment-box-right-reply {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          margin-top: 20px;
          img {
            cursor: pointer;
            width: 35px;
            height: 35px;
            border-radius: 50%;
          }
          .forum-comment-box-right-reply-right {
            margin-left: 10px;
            width: 100%;
            padding: 5px 0 0 0;
            // border-bottom: solid 1px #F9FAFD;
            .forum-comment-box-right-reply-right-userMsg {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              .forum-comment-box-right-reply-right-user {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                div {
                  &:nth-child(1) {
                    font-size: 18px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #1e2134;
                  }
                  &:nth-child(2) {
                    font-size: 18px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #506176;
                    margin: 0 10px;
                  }
                  &:nth-child(3) {
                    font-size: 18px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #1e2134;
                  }
                }
              }
              .forum-comment-box-right-reply-right-time {
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #858585;
              }
            }
            .forum-comment-box-right-reply-right-content {
              margin: 8px 0 5px 0;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #1e2134;
              line-height: 30px;
            }
            .forum-comment-box-right-reply-right-operation {
              margin-bottom: 15px;
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;
              padding-bottom: 15px;
              border-bottom: solid 1px #f9fafd;
              img {
                cursor: pointer;
                width: 16px;
                height: 16px;
              }
              div {
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #506176;
                margin-left: 7px;
              }
            }
          }
          .lookMore {
            cursor: pointer;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #506176;
          }
        }
      }
    }
  }
}
</style>